export default class Utils {

    static escapeHtml(value) {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    static isEmpty(value) {
        return (!value || /^\s*$/.test(value));
    }

    static round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    static isFunction(item) {

        return item && typeof item === "function";
    }

    static readInputImage(input, callback) {

        if (input.files && input.files[0]) {

            let reader = new FileReader();

            reader.onload = function (e) {
                if (Utils.isFunction(callback)) {
                    callback(e.target.result);
                }
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    static isEnabled(item) {
        return item && !item.is(':disabled');
    }

    static isDisabled(item) {
        return item && item.is(':disabled');
    }

    static enable(item) {

        if (Utils.isDisabled(item)) {
            item.prop('disabled', false);
        }
    }

    static disable(item) {

        if (Utils.isEnabled(item)) {
            item.prop('disabled', true);
        }
    }
}
